import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-page-3',
    templateUrl: './custom-page-3.component.html',
    styleUrls: ['./custom-page-3.component.scss'],
})
export class CustomPage3Component implements OnInit {

    constructor(
    ) {

    }

    ngOnInit(): void {

    }
}